export default __webpack_public_path__ + "static/media/favicon.e135c1c4.ico";